import { DecimalPipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";

import { ItemHealth } from "src/app/item-health";
import { DatetimePipe, RuntimePipe, RemoveBaselinePipe } from "src/app/pipes";
import { HealthRightComponent } from "src/app/shared/health-right/health-right.component";
import { HealthStatusIndicatorComponent } from "src/app/shared/health-status-indicator/health-status-indicator.component";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-asset-summary",
	templateUrl: "./asset-summary.component.html",
	styleUrls: ["./asset-summary.component.scss"],
	imports: [RouterLink, HealthStatusIndicatorComponent, HealthRightComponent, DecimalPipe, DatetimePipe, RuntimePipe, RemoveBaselinePipe]
})
export class AssetSummaryComponent implements OnInit {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	time_offset_hours: number;

	public brand = BrandVars;

	public itemHealth: ItemHealth;

	ngOnInit() {
		this.itemHealth = ItemHealth.FromAsset(this.asset as APIResults.FleetAsset);
	}
}
